/**
 * The employee apps whose «Gasbi AI» panel the chat serves, in the backend's order (`AgentRules.ChatApps`,
 * ADR-0004 §2.8): the key goes to `?app=` and `appKey`, the label is what the user reads.
 */
export const CHAT_APPS = [
  { key: 'supply-business-billing', label: 'Supply' },
  { key: 'supply-business-finance', label: 'Supply Finance' },
  { key: 'crm', label: 'CRM' },
  { key: 'supply-admin', label: 'Admin' },
  { key: 'bms', label: 'BMS' },
  { key: 'distribution-households-billing', label: 'Households' },
  { key: 'distribution-households-finance', label: 'Households Finance' },
] as const;

/** The label of a known app key; undefined for no key or an unknown one. */
export const chatAppLabel = (key?: string | null) =>
  CHAT_APPS.find(app => app.key === key)?.label;
